<a class="list-element" tabindex="0" (keydown.enter)="navigate(link)" [href]="link">
    <div class="textWrapper">
        <div class="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
    </div>
    <div class="actions">
        @if (canRemoveItem) {
            <button
                class="resetStyles trashButton"
                (click)="onRemoveElement($event)"
                (keydown.enter)="onRemoveElement($event)"
            >
                <div class="icon" [innerHTML]="trashIcon"></div>
            </button>
        }

        @if (description()) {
            <div class="icon infoIcon" [appTooltip]="description()" [innerHTML]="infoIcon"></div>
        }

        @if (isScheduleItem) {
            <span class="resetStyles scheduleButton" libTooltip [tooltip]="scheduleTooltip">
                @if (schedulerStatusId === 1) {
                    <div class="icon" [innerHTML]="scheduleActiveIcon"></div>
                }
                @if (schedulerStatusId === 2) {
                    <div class="icon" [innerHTML]="schedulePauseIcon"></div>
                }
            </span>
        }
        <app-cell-favorite
            [ngClass]="{ isFavorite: isFavorite }"
            [favorite]="isFavorite"
            (favoriteChange)="onFavoriteChange($event)"
            (keydown.enter)="$event.stopPropagation()"
        ></app-cell-favorite>
    </div>
</a>
